<template>
    <div>
        <Header />
        <div class="top-holder">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <div class="top-left">
                            <!-- <h6>Driving Real Impact Through Housing.</h6> -->
                            <h3>Empowering Members. Building Wealth. Securing Homes.</h3>
                            <p>Shelta Cooperative is the financial and community backbone of Shelta — designed to help households, workers and communities save, earn and access affordable rent, home ownership and essential services.</p>

                            <div class="join-btn d-none d-sm-block">
                                <button class="btn">Get started</button>
                                <button class="btn no-button">Learn how it works</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div>
                            <img class="w-100" src="../assets/cooperative/cooperative-hero.png" alt="cooperate">

                        </div>
                    </div>
                </div>
                <div class="mobile-class">
                    <div class="count-holder">
                        <div class="row">
                            <div class="col-md-6 item-count">
                                <div class="row">
                                    <div class="col-md-6 first-col">
                                        <h2>90%</h2>
                                        <p>Reduction in rent stress</p>
                                    </div>
                                    <div class="col-md-6">
                                        <h2>50+</h2>
                                        <p>Corporate & Merchant Partners</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="join-btn d-block d-sm-none mt-5">
                        <button class="btn">Get started</button>
                        <button class="btn no-button">Learn how it works</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="why-join">
            <div class="container">
                <div class="title-headers">
                    <h3>Why Join The Shelta Cooperative</h3>
                    <h6>Transform your financial future while gaining access to comprehensive housing <br> and household support.</h6>
                </div>
                <div class="row">
                    <div class="col-md-8">
                        <div class="row" style="align-items: center;">
                            <div class="col-md-6">
                                <div class="why-join-item">
                                    <div>
                                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                            <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                            <path d="M36.6667 33.3333C41.4531 33.3333 45.3333 32.1394 45.3333 30.6667C45.3333 29.1939 41.4531 28 36.6667 28C31.8802 28 28 29.1939 28 30.6667C28 32.1394 31.8802 33.3333 36.6667 33.3333Z" stroke="#2AB3E6" stroke-width="2"/>
                                            <path d="M45.3333 36.668C45.3333 38.1408 41.4532 39.3346 36.6667 39.3346C31.8801 39.3346 28 38.1408 28 36.668" stroke="#2AB3E6" stroke-width="2"/>
                                            <path d="M45.3333 30.668V42.4013C45.3333 44.0213 41.4532 45.3346 36.6667 45.3346C31.8801 45.3346 28 44.0213 28 42.4013V30.668" stroke="#2AB3E6" stroke-width="2"/>
                                            <path d="M27.3307 24.0013C32.1172 24.0013 35.9974 22.8074 35.9974 21.3346C35.9974 19.8619 32.1172 18.668 27.3307 18.668C22.5443 18.668 18.6641 19.8619 18.6641 21.3346C18.6641 22.8074 22.5443 24.0013 27.3307 24.0013Z" stroke="#2AB3E6" stroke-width="2"/>
                                            <path d="M23.9974 30.6667C21.475 30.3597 19.1573 29.566 18.6641 28M23.9974 37.3333C21.475 37.0264 19.1573 36.2327 18.6641 34.6667" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round"/>
                                            <path d="M23.9974 43.9987C21.475 43.6918 19.1573 42.898 18.6641 41.332V21.332" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round"/>
                                            <path d="M36 23.9987V21.332" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round"/>
                                        </svg>
                                    </div>
                                    <div>
                                        <h4>Escape Lump-Sum Rent Burden</h4>
                                        <h5>Escape the burden of lump-sum rent through structured savings and flexible rent financing.</h5>
                                    </div>
                                </div>
                                <div class="why-join-item">
                                    <div>
                                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                            <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                            <path d="M39.2799 28.1069L38.8918 27.4216C38.5983 26.9033 38.4515 26.6442 38.2018 26.5409C37.9522 26.4375 37.6697 26.5191 37.1049 26.6821L36.1454 26.9571C35.7847 27.0417 35.4065 26.9937 35.0771 26.8216L34.8122 26.6661C34.5299 26.4821 34.3127 26.2108 34.1925 25.8919L33.9299 25.094C33.7573 24.566 33.6709 24.302 33.4654 24.151C33.2599 24 32.9869 24 32.4409 24H31.5643C31.0183 24 30.7453 24 30.5398 24.151C30.3343 24.302 30.2479 24.566 30.0753 25.094L29.8127 25.8919C29.6925 26.2108 29.4753 26.4821 29.193 26.6661L28.9281 26.8216C28.5988 26.9937 28.2204 27.0417 27.8598 26.9571L26.9003 26.6821C26.3355 26.5191 26.0531 26.4375 25.8034 26.5409C25.5536 26.6442 25.4069 26.9033 25.1133 27.4216L24.7252 28.1069C24.4501 28.5927 24.3125 28.8356 24.3392 29.0941C24.3659 29.3527 24.5501 29.5611 24.9184 29.9779L25.7292 30.9C25.9273 31.1552 26.068 31.6 26.068 31.9999C26.068 32.4 25.9273 32.8447 25.7292 33.0999L24.9184 34.0221C24.5501 34.4388 24.3659 34.6472 24.3392 34.9057C24.3125 35.1644 24.4501 35.4073 24.7252 35.8931L25.1133 36.5783C25.4069 37.0965 25.5536 37.3557 25.8034 37.4591C26.0531 37.5624 26.3355 37.4808 26.9004 37.3177L27.8598 37.0428C28.2205 36.9581 28.5989 37.0063 28.9282 37.1784L29.1931 37.3339C29.4754 37.5179 29.6925 37.7892 29.8127 38.108L30.0753 38.906C30.2479 39.434 30.3343 39.698 30.5398 39.8489C30.7453 40 31.0183 40 31.5643 40H32.4409C32.9869 40 33.2599 40 33.4654 39.8489C33.6709 39.698 33.7573 39.434 33.9299 38.906L34.1925 38.108C34.3127 37.7892 34.5298 37.5179 34.8122 37.3339L35.077 37.1784C35.4063 37.0063 35.7847 36.9581 36.1454 37.0428L37.1049 37.3177C37.6697 37.4808 37.9521 37.5624 38.2018 37.4591C38.4515 37.3557 38.5983 37.0965 38.8919 36.5784L39.2799 35.8931C39.5551 35.4073 39.6927 35.1644 39.6659 34.9057C39.6393 34.6472 39.4551 34.4388 39.0867 34.0221L38.2761 33.0999C38.0778 32.8447 37.9373 32.4 37.9373 31.9999C37.9373 31.6 38.0779 31.1552 38.2761 30.9L39.0867 29.9779C39.4551 29.5611 39.6393 29.3527 39.6659 29.0941C39.6927 28.8356 39.5551 28.5927 39.2799 28.1069Z" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round"/>
                                            <path d="M31.9974 34.3346C33.2861 34.3346 34.3307 33.29 34.3307 32.0013C34.3307 30.7126 33.2861 29.668 31.9974 29.668C30.7087 29.668 29.6641 30.7126 29.6641 32.0013C29.6641 33.29 30.7087 34.3346 31.9974 34.3346Z" stroke="#2AB3E6" stroke-width="2"/>
                                            <path d="M41.3307 18.668V22.4794C38.9257 20.1217 35.6314 18.668 31.9974 18.668C24.6336 18.668 18.6641 24.6375 18.6641 32.0013C18.6641 33.8976 19.0599 35.7014 19.7735 37.3346M22.6641 45.3346V41.5232C25.0691 43.8809 28.3635 45.3346 31.9974 45.3346C39.3611 45.3346 45.3307 39.365 45.3307 32.0013C45.3307 30.105 44.9349 28.3012 44.2213 26.668" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <div>
                                        <h4>Priority Ecosytem SUpport</h4>
                                        <h5>Benefit from priority support across Shelta’s ecosystem — Fixr, Watt, Renovate and CoverPoint.</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="why-join-item">
                                    <div>
                                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                            <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                            <path d="M20 31.9848V35.332C20 39.7318 20 41.9316 21.3668 43.2986C22.7337 44.6654 24.9336 44.6654 29.3333 44.6654H34.6667C39.0664 44.6654 41.2663 44.6654 42.6332 43.2986C44 41.9316 44 39.7318 44 35.332V31.9848C44 29.7431 44 28.6223 43.5255 27.6521C43.0509 26.6819 42.1663 25.9937 40.3968 24.6175L37.7301 22.5434C34.9775 20.4025 33.6012 19.332 32 19.332C30.3988 19.332 29.0225 20.4025 26.2699 22.5434L23.6032 24.6175C21.8338 25.9937 20.9491 26.6819 20.4745 27.6521C20 28.6223 20 29.7431 20 31.9848Z" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M36 44.6667V38C36 36.1144 36 35.1716 35.4143 34.5857C34.8284 34 33.8856 34 32 34C30.1144 34 29.1716 34 28.5858 34.5857C28 35.1716 28 36.1144 28 38V44.6667" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <div>
                                        <h4>Affordable Housing Access</h4>
                                        <h5>Access affordable housing and mortgage opportunities powered by Shelta’s infrastructure.</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="why-join-item">
                            <div>
                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                    <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                    <path d="M21.3359 40.8624V26.7403C21.3359 22.935 21.3359 21.0323 22.5075 19.8501C23.6791 18.668 25.5647 18.668 29.3359 18.668H34.6693C38.4405 18.668 40.3261 18.668 41.4977 19.8501C42.6693 21.0323 42.6693 22.935 42.6693 26.7403V40.8624C42.6693 42.878 42.6693 43.8857 42.0533 44.2824C41.0467 44.9308 39.4907 43.5712 38.7081 43.0777C38.0614 42.6698 37.7382 42.466 37.3793 42.4542C36.9915 42.4414 36.6625 42.637 35.9638 43.0777L33.4159 44.6845C32.7286 45.1178 32.385 45.3346 32.0026 45.3346C31.6202 45.3346 31.2766 45.1178 30.5893 44.6845L28.0414 43.0777C27.3948 42.6698 27.0715 42.466 26.7126 42.4542C26.3249 42.4414 25.9958 42.637 25.2971 43.0777C24.5145 43.5712 22.9584 44.9308 21.9519 44.2824C21.3359 43.8857 21.3359 42.878 21.3359 40.8624Z" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M30.6641 30.668H26.6641" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M34.6641 25.332H26.6641" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div>
                                <h4>Earn COVA Rewards & Dividends</h4>
                                <h5>Earn COVA rewards and dividends while building real financial strength.</h5>
                            </div>
                        </div>
                        <div class="why-join-item">
                            <div>
                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                    <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                    <path d="M30 27.6667V25C30 22.8083 30 21.7125 29.3947 20.9749C29.2839 20.8399 29.1601 20.7161 29.0251 20.6053C28.2875 20 27.1917 20 25 20C22.8083 20 21.7125 20 20.9749 20.6053C20.8399 20.7161 20.7161 20.8399 20.6053 20.9749C20 21.7125 20 22.8083 20 25V27.6667C20 29.8583 20 30.9541 20.6053 31.6917C20.7161 31.8268 20.8399 31.9505 20.9749 32.0613C21.7125 32.6667 22.8083 32.6667 25 32.6667C27.1917 32.6667 28.2875 32.6667 29.0251 32.0613C29.1601 31.9505 29.2839 31.8268 29.3947 31.6917C30 30.9541 30 29.8583 30 27.6667Z" stroke="#2AB3E6" stroke-width="2" stroke-linejoin="round"/>
                                    <path d="M26.3333 36.668H23.6667C22.7363 36.668 22.2711 36.668 21.8926 36.7828C21.0403 37.0413 20.3734 37.7082 20.1148 38.5605C20 38.939 20 39.4042 20 40.3346C20 41.265 20 41.7302 20.1148 42.1088C20.3734 42.961 21.0403 43.628 21.8926 43.8865C22.2711 44.0013 22.7363 44.0013 23.6667 44.0013H26.3333C27.2637 44.0013 27.7289 44.0013 28.1074 43.8865C28.9597 43.628 29.6267 42.961 29.8852 42.1088C30 41.7302 30 41.265 30 40.3346C30 39.4042 30 38.939 29.8852 38.5605C29.6267 37.7082 28.9597 37.0413 28.1074 36.7828C27.7289 36.668 27.2637 36.668 26.3333 36.668Z" stroke="#2AB3E6" stroke-width="2" stroke-linejoin="round"/>
                                    <path d="M44 38.9987V36.332C44 34.1404 44 33.0446 43.3947 32.307C43.2839 32.1719 43.1601 32.0482 43.0251 31.9374C42.2875 31.332 41.1916 31.332 39 31.332C36.8084 31.332 35.7125 31.332 34.9749 31.9374C34.8399 32.0482 34.7161 32.1719 34.6053 32.307C34 33.0446 34 34.1404 34 36.332V38.9987C34 41.1903 34 42.2862 34.6053 43.0238C34.7161 43.1588 34.8399 43.2826 34.9749 43.3934C35.7125 43.9987 36.8084 43.9987 39 43.9987C41.1916 43.9987 42.2875 43.9987 43.0251 43.3934C43.1601 43.2826 43.2839 43.1588 43.3947 43.0238C44 42.2862 44 41.1903 44 38.9987Z" stroke="#2AB3E6" stroke-width="2" stroke-linejoin="round"/>
                                    <path d="M40.3333 20H37.6667C36.7363 20 36.2711 20 35.8925 20.1148C35.0403 20.3734 34.3733 21.0403 34.1148 21.8926C34 22.2711 34 22.7363 34 23.6667C34 24.597 34 25.0622 34.1148 25.4408C34.3733 26.293 35.0403 26.96 35.8925 27.2185C36.2711 27.3333 36.7363 27.3333 37.6667 27.3333H40.3333C41.2637 27.3333 41.7289 27.3333 42.1075 27.2185C42.9597 26.96 43.6267 26.293 43.8852 25.4408C44 25.0622 44 24.597 44 23.6667C44 22.7363 44 22.2711 43.8852 21.8926C43.6267 21.0403 42.9597 20.3734 42.1075 20.1148C41.7289 20 41.2637 20 40.3333 20Z" stroke="#2AB3E6" stroke-width="2" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div>
                                <h4>Digitalized Cooperative System</h4>
                                <h5>Be part of a trusted cooperative system that merges finance, housing and community growth.</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="core-features">
                <div class="title-headers">
                    <h3>Core Features & Benefits</h3>
                    <h6>Comprehensive solutions designed to support your housing <br> and financial journey</h6>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <div class="why-join-item" style="border: 1.5px solid #EBEBEB;">
                            <div>
                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                    <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                    <path d="M36.6667 33.3333C41.4531 33.3333 45.3333 32.1394 45.3333 30.6667C45.3333 29.1939 41.4531 28 36.6667 28C31.8802 28 28 29.1939 28 30.6667C28 32.1394 31.8802 33.3333 36.6667 33.3333Z" stroke="#2AB3E6" stroke-width="2"/>
                                    <path d="M45.3333 36.668C45.3333 38.1408 41.4532 39.3346 36.6667 39.3346C31.8801 39.3346 28 38.1408 28 36.668" stroke="#2AB3E6" stroke-width="2"/>
                                    <path d="M45.3333 30.668V42.4013C45.3333 44.0213 41.4532 45.3346 36.6667 45.3346C31.8801 45.3346 28 44.0213 28 42.4013V30.668" stroke="#2AB3E6" stroke-width="2"/>
                                    <path d="M27.3307 24.0013C32.1172 24.0013 35.9974 22.8074 35.9974 21.3346C35.9974 19.8619 32.1172 18.668 27.3307 18.668C22.5443 18.668 18.6641 19.8619 18.6641 21.3346C18.6641 22.8074 22.5443 24.0013 27.3307 24.0013Z" stroke="#2AB3E6" stroke-width="2"/>
                                    <path d="M23.9974 30.6667C21.475 30.3597 19.1573 29.566 18.6641 28M23.9974 37.3333C21.475 37.0264 19.1573 36.2327 18.6641 34.6667" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round"/>
                                    <path d="M23.9974 43.9987C21.475 43.6918 19.1573 42.898 18.6641 41.332V21.332" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round"/>
                                    <path d="M36 23.9987V21.332" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round"/>
                                </svg>
                            </div>
                            <div>
                                <h4>Affordable Housing Access</h4>
                                <h5>Helping members transition from tenants to homeowners through structured, flexible plans.</h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="why-join-item" style="border: 1.5px solid #EBEBEB;">
                            <div>
                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                    <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                    <path d="M20 31.9848V35.332C20 39.7318 20 41.9316 21.3668 43.2986C22.7337 44.6654 24.9336 44.6654 29.3333 44.6654H34.6667C39.0664 44.6654 41.2663 44.6654 42.6332 43.2986C44 41.9316 44 39.7318 44 35.332V31.9848C44 29.7431 44 28.6223 43.5255 27.6521C43.0509 26.6819 42.1663 25.9937 40.3968 24.6175L37.7301 22.5434C34.9775 20.4025 33.6012 19.332 32 19.332C30.3988 19.332 29.0225 20.4025 26.2699 22.5434L23.6032 24.6175C21.8338 25.9937 20.9491 26.6819 20.4745 27.6521C20 28.6223 20 29.7431 20 31.9848Z" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M36 44.6667V38C36 36.1144 36 35.1716 35.4143 34.5857C34.8284 34 33.8856 34 32 34C30.1144 34 29.1716 34 28.5858 34.5857C28 35.1716 28 36.1144 28 38V44.6667" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div>
                                <h4>Mortgage & Rent-to-Own Support</h4>
                                <h5>Cooperative-backed mortgage partnerships and rent-to-own programs tailored for income levels.</h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="why-join-item" style="border: 1.5px solid #EBEBEB;">
                            <div>
                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                    <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                    <path d="M21.3359 40.8624V26.7403C21.3359 22.935 21.3359 21.0323 22.5075 19.8501C23.6791 18.668 25.5647 18.668 29.3359 18.668H34.6693C38.4405 18.668 40.3261 18.668 41.4977 19.8501C42.6693 21.0323 42.6693 22.935 42.6693 26.7403V40.8624C42.6693 42.878 42.6693 43.8857 42.0533 44.2824C41.0467 44.9308 39.4907 43.5712 38.7081 43.0777C38.0614 42.6698 37.7382 42.466 37.3793 42.4542C36.9915 42.4414 36.6625 42.637 35.9638 43.0777L33.4159 44.6845C32.7286 45.1178 32.385 45.3346 32.0026 45.3346C31.6202 45.3346 31.2766 45.1178 30.5893 44.6845L28.0414 43.0777C27.3948 42.6698 27.0715 42.466 26.7126 42.4542C26.3249 42.4414 25.9958 42.637 25.2971 43.0777C24.5145 43.5712 22.9584 44.9308 21.9519 44.2824C21.3359 43.8857 21.3359 42.878 21.3359 40.8624Z" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M30.6641 30.668H26.6641" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M34.6641 25.332H26.6641" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div>
                                <h4>Flexible Rent & Credit Plans</h4>
                                <h5>Members can pay rent monthly, quarterly, or annually while Shelta covers landlords upfront.</h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="why-join-item" style="border: 1.5px solid #EBEBEB;">
                            <div>
                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                    <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                    <path d="M39.2799 28.1069L38.8918 27.4216C38.5983 26.9033 38.4515 26.6442 38.2018 26.5409C37.9522 26.4375 37.6697 26.5191 37.1049 26.6821L36.1454 26.9571C35.7847 27.0417 35.4065 26.9937 35.0771 26.8216L34.8122 26.6661C34.5299 26.4821 34.3127 26.2108 34.1925 25.8919L33.9299 25.094C33.7573 24.566 33.6709 24.302 33.4654 24.151C33.2599 24 32.9869 24 32.4409 24H31.5643C31.0183 24 30.7453 24 30.5398 24.151C30.3343 24.302 30.2479 24.566 30.0753 25.094L29.8127 25.8919C29.6925 26.2108 29.4753 26.4821 29.193 26.6661L28.9281 26.8216C28.5988 26.9937 28.2204 27.0417 27.8598 26.9571L26.9003 26.6821C26.3355 26.5191 26.0531 26.4375 25.8034 26.5409C25.5536 26.6442 25.4069 26.9033 25.1133 27.4216L24.7252 28.1069C24.4501 28.5927 24.3125 28.8356 24.3392 29.0941C24.3659 29.3527 24.5501 29.5611 24.9184 29.9779L25.7292 30.9C25.9273 31.1552 26.068 31.6 26.068 31.9999C26.068 32.4 25.9273 32.8447 25.7292 33.0999L24.9184 34.0221C24.5501 34.4388 24.3659 34.6472 24.3392 34.9057C24.3125 35.1644 24.4501 35.4073 24.7252 35.8931L25.1133 36.5783C25.4069 37.0965 25.5536 37.3557 25.8034 37.4591C26.0531 37.5624 26.3355 37.4808 26.9004 37.3177L27.8598 37.0428C28.2205 36.9581 28.5989 37.0063 28.9282 37.1784L29.1931 37.3339C29.4754 37.5179 29.6925 37.7892 29.8127 38.108L30.0753 38.906C30.2479 39.434 30.3343 39.698 30.5398 39.8489C30.7453 40 31.0183 40 31.5643 40H32.4409C32.9869 40 33.2599 40 33.4654 39.8489C33.6709 39.698 33.7573 39.434 33.9299 38.906L34.1925 38.108C34.3127 37.7892 34.5298 37.5179 34.8122 37.3339L35.077 37.1784C35.4063 37.0063 35.7847 36.9581 36.1454 37.0428L37.1049 37.3177C37.6697 37.4808 37.9521 37.5624 38.2018 37.4591C38.4515 37.3557 38.5983 37.0965 38.8919 36.5784L39.2799 35.8931C39.5551 35.4073 39.6927 35.1644 39.6659 34.9057C39.6393 34.6472 39.4551 34.4388 39.0867 34.0221L38.2761 33.0999C38.0778 32.8447 37.9373 32.4 37.9373 31.9999C37.9373 31.6 38.0779 31.1552 38.2761 30.9L39.0867 29.9779C39.4551 29.5611 39.6393 29.3527 39.6659 29.0941C39.6927 28.8356 39.5551 28.5927 39.2799 28.1069Z" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round"/>
                                    <path d="M31.9974 34.3346C33.2861 34.3346 34.3307 33.29 34.3307 32.0013C34.3307 30.7126 33.2861 29.668 31.9974 29.668C30.7087 29.668 29.6641 30.7126 29.6641 32.0013C29.6641 33.29 30.7087 34.3346 31.9974 34.3346Z" stroke="#2AB3E6" stroke-width="2"/>
                                    <path d="M41.3307 18.668V22.4794C38.9257 20.1217 35.6314 18.668 31.9974 18.668C24.6336 18.668 18.6641 24.6375 18.6641 32.0013C18.6641 33.8976 19.0599 35.7014 19.7735 37.3346M22.6641 45.3346V41.5232C25.0691 43.8809 28.3635 45.3346 31.9974 45.3346C39.3611 45.3346 45.3307 39.365 45.3307 32.0013C45.3307 30.105 44.9349 28.3012 44.2213 26.668" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div>
                                <h4>Home Renovation Loans</h4>
                                <h5>Low-interest credit for household upgrades through Shelta Renovate.</h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="why-join-item" style="border: 1.5px solid #EBEBEB;">
                            <div>
                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                    <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                    <path d="M28 42.668C22.9719 41.5104 20 36.9042 20 32.6816C20 27.6606 24.4935 22.6989 27.6475 19.8346C29.3605 18.2791 31.9729 18.2791 33.6857 19.8346C35.6949 21.6591 38.0999 24.3348 39.6681 27.3346" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round"/>
                                    <path d="M38.6641 36.6679C36.6641 38.0013 33.3307 40.6679 30.6641 45.3346M33.3307 41.3346C29.779 33.5222 37.1103 30.9819 42.5639 30.689C43.2221 30.6537 43.5511 30.6359 43.7874 30.8639C44.0238 31.0918 44.0101 31.4167 43.9829 32.0666C43.7566 37.4702 41.3237 44.8103 33.3307 41.3346Z" stroke="#2AB3E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div>
                                <h4>Household Support Integration</h4>
                                <h5>Members enjoy priority access to Fixr home services, Watt solar energy solutions and Shelta Impact Projects.</h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="why-join-item" style="border: 1.5px solid #EBEBEB;">
                            <div>
                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                    <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                    <path d="M30 27.6667V25C30 22.8083 30 21.7125 29.3947 20.9749C29.2839 20.8399 29.1601 20.7161 29.0251 20.6053C28.2875 20 27.1917 20 25 20C22.8083 20 21.7125 20 20.9749 20.6053C20.8399 20.7161 20.7161 20.8399 20.6053 20.9749C20 21.7125 20 22.8083 20 25V27.6667C20 29.8583 20 30.9541 20.6053 31.6917C20.7161 31.8268 20.8399 31.9505 20.9749 32.0613C21.7125 32.6667 22.8083 32.6667 25 32.6667C27.1917 32.6667 28.2875 32.6667 29.0251 32.0613C29.1601 31.9505 29.2839 31.8268 29.3947 31.6917C30 30.9541 30 29.8583 30 27.6667Z" stroke="#2AB3E6" stroke-width="2" stroke-linejoin="round"/>
                                    <path d="M26.3333 36.668H23.6667C22.7363 36.668 22.2711 36.668 21.8926 36.7828C21.0403 37.0413 20.3734 37.7082 20.1148 38.5605C20 38.939 20 39.4042 20 40.3346C20 41.265 20 41.7302 20.1148 42.1088C20.3734 42.961 21.0403 43.628 21.8926 43.8865C22.2711 44.0013 22.7363 44.0013 23.6667 44.0013H26.3333C27.2637 44.0013 27.7289 44.0013 28.1074 43.8865C28.9597 43.628 29.6267 42.961 29.8852 42.1088C30 41.7302 30 41.265 30 40.3346C30 39.4042 30 38.939 29.8852 38.5605C29.6267 37.7082 28.9597 37.0413 28.1074 36.7828C27.7289 36.668 27.2637 36.668 26.3333 36.668Z" stroke="#2AB3E6" stroke-width="2" stroke-linejoin="round"/>
                                    <path d="M44 38.9987V36.332C44 34.1404 44 33.0446 43.3947 32.307C43.2839 32.1719 43.1601 32.0482 43.0251 31.9374C42.2875 31.332 41.1916 31.332 39 31.332C36.8084 31.332 35.7125 31.332 34.9749 31.9374C34.8399 32.0482 34.7161 32.1719 34.6053 32.307C34 33.0446 34 34.1404 34 36.332V38.9987C34 41.1903 34 42.2862 34.6053 43.0238C34.7161 43.1588 34.8399 43.2826 34.9749 43.3934C35.7125 43.9987 36.8084 43.9987 39 43.9987C41.1916 43.9987 42.2875 43.9987 43.0251 43.3934C43.1601 43.2826 43.2839 43.1588 43.3947 43.0238C44 42.2862 44 41.1903 44 38.9987Z" stroke="#2AB3E6" stroke-width="2" stroke-linejoin="round"/>
                                    <path d="M40.3333 20H37.6667C36.7363 20 36.2711 20 35.8925 20.1148C35.0403 20.3734 34.3733 21.0403 34.1148 21.8926C34 22.2711 34 22.7363 34 23.6667C34 24.597 34 25.0622 34.1148 25.4408C34.3733 26.293 35.0403 26.96 35.8925 27.2185C36.2711 27.3333 36.7363 27.3333 37.6667 27.3333H40.3333C41.2637 27.3333 41.7289 27.3333 42.1075 27.2185C42.9597 26.96 43.6267 26.293 43.8852 25.4408C44 25.0622 44 24.597 44 23.6667C44 22.7363 44 22.2711 43.8852 21.8926C43.6267 21.0403 42.9597 20.3734 42.1075 20.1148C41.7289 20 41.2637 20 40.3333 20Z" stroke="#2AB3E6" stroke-width="2" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div>
                                <h4>Savings & Investment Growth</h4>
                                <h5>Daily, weekly, or monthly contributions that earn dividends and rewards through COVA, Shelta’s reward and credit ecosystem.</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="membership-path">
            <div class="container">
                <div class="title-headers">
                    <h3>Choose Your Membership Path</h3>
                    <h6>Join the cooperative that fits your housing and financial goals</h6>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <div class="membership-item">
                            <h4>Household</h4>
                            <p>Individuals or families saving or financing towards rent or home ownership</p>
                            <h5>Benefit</h5>
                            <div class="membership-list">
                                <div>
                                    <span>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="1" width="22" height="22" rx="11" fill="#F9FAFB"/>
                                            <rect x="1" y="1" width="22" height="22" rx="11" stroke="#F9FAFB" stroke-width="2"/>
                                            <path d="M15.3359 6.72391C14.3553 6.15668 13.2169 5.83203 12.0026 5.83203C8.3207 5.83203 5.33594 8.8168 5.33594 12.4987C5.33594 16.1806 8.3207 19.1654 12.0026 19.1654C15.6845 19.1654 18.6693 16.1806 18.6693 12.4987C18.6693 12.0421 18.6233 11.5962 18.5359 11.1654" stroke="#2AB3E6" stroke-width="1.5" stroke-linecap="round"/>
                                            <path d="M9.33594 12.832C9.33594 12.832 10.3359 12.832 11.6693 15.1654C11.6693 15.1654 15.3751 9.05425 18.6693 7.83203" stroke="#2AB3E6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </span>
                                </div>
                                <p>Rent support and home ownership pathways</p>
                            </div>
                            <div class="outlined-button-primary">
                                <button class="btn">Join now</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="membership-item">
                            <h4>Corporate</h4>
                            <p>Organizations and cooperatives partnering with Shelta</p>
                            <h5>Benefit</h5>
                            <div class="membership-list">
                                <div>
                                    <span>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="1" width="22" height="22" rx="11" fill="#F9FAFB"/>
                                            <rect x="1" y="1" width="22" height="22" rx="11" stroke="#F9FAFB" stroke-width="2"/>
                                            <path d="M15.3359 6.72391C14.3553 6.15668 13.2169 5.83203 12.0026 5.83203C8.3207 5.83203 5.33594 8.8168 5.33594 12.4987C5.33594 16.1806 8.3207 19.1654 12.0026 19.1654C15.6845 19.1654 18.6693 16.1806 18.6693 12.4987C18.6693 12.0421 18.6233 11.5962 18.5359 11.1654" stroke="#2AB3E6" stroke-width="1.5" stroke-linecap="round"/>
                                            <path d="M9.33594 12.832C9.33594 12.832 10.3359 12.832 11.6693 15.1654C11.6693 15.1654 15.3751 9.05425 18.6693 7.83203" stroke="#2AB3E6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </span>
                                </div>
                                <p>Staff housing schemes and welfare integration</p>
                            </div>
                            <div class="outlined-button-primary">
                                <button class="btn">Join now</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="membership-item">
                            <h4>Association and Community Members</h4>
                            <p>Estates, associations and religious groups</p>
                            <h5>Benefit</h5>
                            <div class="membership-list">
                                <div>
                                    <span>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="1" width="22" height="22" rx="11" fill="#F9FAFB"/>
                                            <rect x="1" y="1" width="22" height="22" rx="11" stroke="#F9FAFB" stroke-width="2"/>
                                            <path d="M15.3359 6.72391C14.3553 6.15668 13.2169 5.83203 12.0026 5.83203C8.3207 5.83203 5.33594 8.8168 5.33594 12.4987C5.33594 16.1806 8.3207 19.1654 12.0026 19.1654C15.6845 19.1654 18.6693 16.1806 18.6693 12.4987C18.6693 12.0421 18.6233 11.5962 18.5359 11.1654" stroke="#2AB3E6" stroke-width="1.5" stroke-linecap="round"/>
                                            <path d="M9.33594 12.832C9.33594 12.832 10.3359 12.832 11.6693 15.1654C11.6693 15.1654 15.3751 9.05425 18.6693 7.83203" stroke="#2AB3E6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </span>
                                </div>
                                <p>Collective savings, home projects and development initiatives</p>
                            </div>
                            <div class="outlined-button-primary">
                                <button class="btn">Join now</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="governance-transparecy">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <div class="gov-left-item">
                            <h3>Governance & Transparency</h3>
                            <h6>Real stories from partners who are empowering their people through Shelta.</h6>

                            <p class="mt-5 mb-5">“Shelta Cooperative operates under SheltaCo, ensuring full NDPR compliance, transparent reporting and accountability.”</p>
                            <p>Members have access to the Shelta Cooperative Dashboard where they can track contributions, savings, dividends and homeownership progress in real time.</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div>
                            <img class="w-100" src="../assets/cooperative/barcode.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="impact-vision">
            <div class="container">
               <div class="row">
                    <div class="col-md-10 m-auto" style="position: relative;">
                        <button class="btn">Our Impact Vision</button>
                        <h3>To make every household in Africa financially and socially empowered to live better, own better and grow together.</h3>
                        <p>“Shelta Cooperative is not just a savings platform - it is Africa’s gateway to affordable housing, financial inclusion and household stability. It connects people, property and progress — ensuring every member can access the shelter, services and support they deserve.”</p>
                    </div>
               </div>
            </div>
        </div>

        <div class="container">
            <img class="w-100" src="../assets/cooperative/bottom-hero.png" alt="people">
        </div>

        <div class="container">
            <div class="empower-holder">
                <h3>Empower Your Household. Grow with Shelta.</h3>
                <div class="row ">
                    <div class="col-md-7 m-auto">
                        
                        <p>Become part of Shelta Cooperative and start your journey toward affordable  housing, financial growth, and lasting community impact. Together, we’re making ownership possible for every household.</p>
                        <div class="white-buttons">
                            <button class="btn">Join the Cooperative</button>
                            <button class="btn">Contact Support</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <FooterMain />
    </div>
</template>

<script>
import FooterMain from "../views/FooterMain";
import Header from "../views/Header";
export default {
  name: "Cooperative",
  components: {
    Header,
    FooterMain,
    // HomePart,
    // PromoGif
  },
  data() {
    return {
        isMobile: false,
    };
  },
  created() {
    this.checkScreen();
    window.addEventListener("resize", this.checkScreen);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreen);
  },
  mounted() {
  },
  methods: {
    checkScreen() {
      this.isMobile = window.innerWidth <= 768; // your breakpoint
    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped>

.top-holder {
    margin-top: 6rem;
    padding-top: 4rem;
    padding-bottom: 4rem;
    // background: linear-gradient(270deg, #E0F2F7 0%, #F0F8FF 50%, #FFFFFF 100%), url(../assets/cooperate/cooperate-bg.png);
    background: url(../assets/cooperate/cooperate-bg.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    position: relative;
}

.top-holder::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.85); /* White overlay with 50% opacity */
    /* Adjust the '0.5' (alpha value) from 0.0 (fully transparent) to 1.0 (fully opaque) */
}

.top-left {
    h6 {
        background: #FFB100;
        color: #ffffff;
        border-radius: 50px;
        padding: 8px 30px;
        min-height: 35px;
        margin-bottom: 20px;
        font-family: Lato;
        font-weight: 400;
        font-size: 18px;
        line-height: 30px;
        width: fit-content;
        text-align: left;
    }
    h3 {
        font-family: Lato;
        font-weight: 700;
        // font-style: Bold;
        font-size: 32px;
        line-height: 50px;
        text-align: left;
        color: #1A1A1A;
        margin-bottom: 20px;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #555555;
        text-align: left;
    }

}

.join-btn {
    margin-top: 7rem;
    text-align: left;
    button:first-child {
        background: #2AB3E6;
        color: #ffffff;
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        outline: 0;
        box-shadow: none;
    }
    button:nth-child(2) {
        color: #2AB3E6;
        // color: blue !important;
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        outline: 0;
        box-shadow: none;
    }
}

.count-holder {
    // #EBEBEB
    // background: #FFFFFF;
    // padding: 16px 24px;
    // margin-top: 8rem;
    // border-radius: 16px;
    div:not(:last-child) {
        border-right: 1px solid #EBEBEB;
        padding-right: 4rem;
    }
    h2 {
        font-family: Lato;
        font-weight: 700;
        font-size: 18px;
        // line-height: 40px;
        text-align: left;
        color: #1A1A1A;
        // margin-bottom: 0;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        text-align: left;
        // line-height: 40;
        color: #555555;
        // margin-bottom: 0;
    }
}

.title-headers {
    margin-bottom: 70px;
    h3 {
        font-family: Lato;
        font-weight: 600;
        font-size: 36px;
        line-height: 24px;
        color: #1F2223;
        text-align: center;
        margin-bottom: 20px;

    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 23px;
        color: #555555;
        text-align: center;
    }
}
.why-join {
    background: #F8F9FA;
    padding: 80px 0 60px 0;
}
.why-join-item {
    background: #ffffff;
    padding: 32px;
    border-radius: 16px;
    margin-bottom: 20px;
    border: 1.5px solid #ffffff;
    h4 {
        font-family: Lato;
        font-weight: 500;
        font-size: 18px;
        line-height: 23px;
        color: #1A1A1A;
        text-align: center;
    }
    h5 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 23px;
        color: #555555;
        text-align: center;
    }
}
.why-join-item:hover {
    border: 1.5px solid #2AB3E6;
}

.core-features {
    // background: ;
    padding: 80px 0 60px 0;

}

.membership-path {
    background: #F8F9FA;
    padding: 80px 0 60px 0;
}

.membership-item {
    border: 2px solid #E6E8EB;
    padding: 32px;
    border-radius: 16px;
    margin-bottom: 20px;
    h4 {
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        text-align: left;
        line-height: 23px;
        color: #1A1A1A;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        text-align: left;
        font-size: 14px;
        color: #555555;
        line-height: 23px;
    }
    h5 {
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        text-align: left;
        line-height: 23px;
        color: #1A1A1A;
    }
}
.membership-item:hover {
    border: 2px solid #2AB3E6;
}

.membership-list {
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 15px;
    p {
        line-height: 18px;
    }
}

.outlined-button-primary {
    margin-top: 30px;
    button {
        border: 1px solid #2AB3E6;
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        color: #2AB3E6;
        width: 100%;
        border-radius: 12px;
        outline: 0;
        box-shadow: none;
    }
    button:hover {
        border: 1px solid #2AB3E6;
        color: #ffffff;
        background: #2AB3E6;
    }
}
.button-primary-block {
    margin-top: 30px;
    button {
        background: #2AB3E6;
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        width: 100%;
        border-radius: 12px;
        outline: 0;
        box-shadow: none;
    }
}


.governance-transparecy {
    padding: 60px 15px 80px 15px;
}
.gov-left-item {
    h3 {
        font-family: Lato;
        font-weight: 600;
        font-size: 36px;
        line-height: 42px;
        color: #1A1A1A;
        text-align: left;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 23px;
        color: #555555;
        text-align: left;
    }
    p {
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: #555555;
        text-align: left;
    }
}

.impact-vision {
    // margin-top: 6rem;
    padding-top: 4rem;
    padding-bottom: 4rem;
    // background: linear-gradient(270deg, #E0F2F7 0%, #F0F8FF 50%, #FFFFFF 100%), url(../assets/cooperate/cooperate-bg.png);
    background: url(../assets/cooperate/cooperate-bg.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    position: relative;
}

.impact-vision::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // background-color: rgba(0, 51, 234, 0.05)
    background-color: rgba(255, 255, 255, 0.85); /* White overlay with 50% opacity */
    // box-shadow: 0px 4px 4px 0px #0033EA0D;
}

.impact-vision {
    button {
        background: #2AB3E6;
        color: #ffffff;
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        border-radius: 50px;
        // padding: 11px 20px;
        margin-bottom: 30px;
        cursor: none !important;
        box-shadow: none;
        outline: 0;
    }
    h3 {
        font-family: Lato;
        font-weight: 500;
        font-size: 28px;
        line-height: 40px;
        color: #292D32;
        text-align: center;
        margin-bottom: 40px;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 20px;
        line-height: 33px;
        text-align: center;
        color: #555555;
    }
}


.empower-holder {
    background: #2AB3E6;
    padding: 60px 15px;
    border-radius: 16px;
    margin: 60px 0;
    h3 {
        font-family: Lato;
        font-weight: 700;
        font-size: 36px;
        line-height: 34px;
        text-align: center;
        color: #ffffff;
        margin-bottom: 30px;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        text-align: center;
        color: #FAFAFA;
        margin-bottom: 30px;
    }
}
.white-buttons {
    margin-top: 30px;
    text-align: center;
    button {
        box-shadow: none;
        outline: 0;
    }
    button:first-child {
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        border-radius: 8px;
        color: #2AB3E6;
        background: #ffffff;
    }
    button:last-child {
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        color: #ffffff;
        background: #2AB3E6;
    }
}

@media (max-width: 767px) { /* Adjust breakpoint as needed for "mobile" */
    .top-holder {
        background: url(../assets/cooperate/cooperate-bg.png);
        
        // background: linear-gradient(
        //     to bottom,
        //     rgba(255, 255, 255, 0.85) 0%,
        //     rgba(0, 0, 0, 0.5) 100%
        // );
        
    }
    .top-holder::before {
        background-color: rgba(255, 255, 255, 0.85);
    }
    .top-left {
        h3 {
            line-height: 35px;
            font-size: 24px;
        }
    }
    .title-headers {
        h3 {
            line-height: 30px;
            font-size: 24px;
        }
    }
    .container > *:not(:last-child) {
        border-right: none;
    }
    .mobile-class {
        background: #fbfafa;
        border-radius: 16px;
        margin-top: 35px;
        padding-bottom: 10px;
        position: relative;
        .join-btn {
            text-align: center;
            margin-bottom: 14px;
            margin-top: 10px !important;
        }

    }
    .count-holder {
        padding: 40px;
    // #EBEBEB
        div:not(:last-child) {
            border-right: none;
            padding-right: 0;
        }

    }
    .gov-left-item {
        h3 {
            // font-size: 23px;
            // line-height: 34px;
            font-size: 31px;
            line-height: 43px;
        }
    }
    .empower-holder {
        h3 {
            font-size: 21px;
            line-height: 28px;
        }
    }
    .impact-vision {
        padding-top: 1px;
    }
}
</style>